import { useParams } from 'react-router-dom';
import { useGetFanLetterById } from '../../../domains/bettie/ui/hooks/useGetFanLetterById';
import { useGenerateFanLetter } from '../../../domains/bettie/ui/hooks/useGenerateFanLetter';

export const useFanLetterDetail = () => {
  const { letterId } = useParams();

  const { data: fanLetter, isLoading: isLoadingFanLetter } = useGetFanLetterById({
    letterId: letterId as string
  });
  const { mutateAsync: generateFanLetter, isLoading: isLoadingGenerate } = useGenerateFanLetter({
    letterId: letterId as string
  });

  const handleOpenFanLetter = async () => {
    if (!letterId) return;
    try {
      const response = await generateFanLetter({ id: letterId });

      if (!response.fanLetter) {
        throw new Error('Failed to read fan letter');
      }
    } catch (error) {
      // biome-ignore lint: error is handled
      console.error(error);
    }
  };

  return {
    fanLetter,
    handleOpenFanLetter,
    isLoadingFanLetter,
    isLoadingGenerate
  };
};
